export const BlocklyCustomDE = {
    UNDO: "\u21B6 Rückgängig",
    REDO: "\u21B7 Wiederholen",
    CLEAN_UP: "\u2833 Aufräumen",
    DELETE_BLOCK: "\u2298 Löschen",
    DELETE_X_BLOCKS: "\u2298 Lösche %1 Blöcke",
    LOAD: "\u{1F845} Programm laden",
    SAVE: "\u{1F847} Programm speichern",
    CODE_EXPORT: "\u2756 Code exportieren",
    INLINE_INPUTS: "\u25EB Horizontal anordnen",
    EXTERNAL_INPUTS: "\u229F Vertikal anordnen",
    DUPLICATE_BLOCK: "\uA698 Klonen",
    ADD_COMMENT: "\u270E Kommentar",
    
    REMOVE_COMMENT: "\u{1F7A9} Kommentar löschen",
    COLLAPSE_BLOCK: "\u25F2 Reduzieren",
    EXPAND_BLOCK: "\u29C9 Erweitern",
    DISABLE_BLOCK: "\u{1F5F2} Deaktivieren",
    ENABLE_BLOCK: "\u{1F5F2} Aktivieren",

    EXEC_ERROR: "Programmfehler",
    EXEC_SUCCESS: "Programm abgeschlossen",
    EMPTY_PROGRAM: "Leeres Programm",
    SEE_CONSOLE: "Weitere Details in der Browser-Konsole.",

    ROCKSI_CATEGORY_MOVE: "Bewegung",
    ROCKSI_CATEGORY_OBJECTS: "Objekte",
    ROCKSI_CATEGORY_LOGIC: "Logik",
    ROCKSI_CATEGORY_EXTRAS: "Extras",
    ROCKSI_CATEGORY_EXAMPLES: "Beispiele",

    ROCKSI_BLOCK_MOVE: "Bewegung %1",
    ROCKSI_BLOCK_MOVE_TOOLTIP: "Füge rechts eine Joint oder Task Space Pose hinzu, zu der sich der Roboter bewegen soll",
    ROCKSI_BLOCK_DEFAULTPOSE: "Startpose",
    ROCKSI_BLOCK_DEFAULTPOSE_TOOLTIP: "Die Standard-Pose des Roboters",
    ROCKSI_BLOCK_JOINTSPACEPOSE_TOOLTIP: "Eine Pose im Gelenkwinkelraum (ein Winkel pro Gelenk beginnend an der Basis)",
    ROCKSI_BLOCK_TASKSPACEPOSE_TOOLTIP: "Eine Pose im Arbeitsraum (Position und Orientierung im Raum)",
    ROCKSI_BLOCK_JOINTABSOLUTE: "Gelenkwinkel (absolut) %1 %2",
    ROCKSI_BLOCK_JOINTABSOLUTE_TOOLTIP: "Bewege ein einzelnes Gelenk in eine bestimmte Position",
    ROCKSI_BLOCK_JOINTRELATIVE: "Gelenkwinkel (relativ) %1 %2",
    ROCKSI_BLOCK_JOINTRELATIVE_TOOLTIP: "Drehe ein einzelnes Gelenk um den angegebenen Winkel",

    ROCKSI_BLOCK_GRIPPEROPEN: "Greifer öffnen",
    ROCKSI_BLOCK_GRIPPEROPEN_TOOLTIP: "Öffnet den Greifer auf volle Weite",
    ROCKSI_BLOCK_GRIPPERCLOSE: "Greifer schließen",
    ROCKSI_BLOCK_GRIPPERCLOSE_TOOLTIP: "Schließt den Greifer vollständig",
    ROCKSI_BLOCK_SIMOBJECT: "Platziere einen %1", 
    ROCKSI_BLOCK_SIMOBJECT_CUBE: "Würfel",
    ROCKSI_BLOCK_SIMOBJECT_SPHERE: "Kugel",
    ROCKSI_BLOCK_SIMOBJECT_ROCK: "Stein",
    ROCKSI_BLOCK_SIMOBJECT_SHAFT: "Welle",
    ROCKSI_BLOCK_SIMOBJECT_CUSTOM: "Eigenes Objekt...",
    ROCKSI_BLOCK_SIMOBJECT_COLOR: "in der Farbe %1",
    ROCKSI_BLOCK_SIMOBJECT_POSITION: "an Position %1",
    ROCKSI_BLOCK_SIMOBJECT_SCALE: "in der Skalierung %1",
    ROCKSI_BLOCK_SIMOBJECT_TOOLTIP: "Fügt ein Objekt hinzu, dass der Roboter greifen kann",
    ROCKSI_BLOCK_PHYSICSDONE: "Physiksimulation abgeschlossen?",
    ROCKSI_BLOCK_PHYSICSDONE_TOOLTIP: "Gibt Wahr zurück sobald sich kein Objekt mehr bewegt (ausgeschlossen der Roboter)",
    ROCKSI_BLOCK_HOLDING: "Gegriffen?",
    ROCKSI_BLOCK_HOLDING_TOOLTIP: "Gibt Wahr zurück wenn der Roboter etwas gegriffen hat",

    ROCKSI_BLOCK_COMMENT: "Kommentar %1",
    ROCKSI_BLOCK_COMMENT_TOOLTIP: "Kommentar, hat keine Auswirkungen",
    ROCKSI_BLOCK_WAIT: "Warte %1 Sekunden",
    ROCKSI_BLOCK_WAIT_TOOLTIP: "Warte eine bestimmte Zeit, bevor der nächste Block ausgeführt wird",
    ROCKSI_BLOCK_SETSPEED: "Geschwindigkeit %1 %2 %%",
    ROCKSI_BLOCK_SETSPEED_MOVE: "Bewegung",
    ROCKSI_BLOCK_SETSPEED_GRIPPER: "Greifer",
    ROCKSI_BLOCK_SETSPEED_TOOLTIP: "Ändere die Bewegungsgeschwindigkeit des Roboters",
    ROCKSI_BLOCK_JOINTLOCK: "Sperre %1",
    ROCKSI_BLOCK_JOINTLOCK_TOOLTIP: "Verhindert Änderungen des Gelenkwinkels für das gewählte Gelenk",
    ROCKSI_BLOCK_JOINTUNLOCK: "Entsperre %1",
    ROCKSI_BLOCK_JOINTUNLOCK_TOOLTIP: "Erlaubt Änderungen des Gelenkwinkels für das gewählte Gelenk",

    ROCKSI_BLOCK_SCALE: "%1",
    ROCKSI_BLOCK_SCALE_TOOLTIP: "Ein Faktor",

    ROCKSI_EXAMPLE_PICK_N_PLACE: "Pick & Place: ein Objekt aufheben und loslassen",
    ROCKSI_EXAMPLE_PICK_N_PLACE_COMMENT_1: "Eine Gelenkwinkelpose ist immer zuverlässiger!"
}